import { create } from 'zustand';
import { fetchDonations } from '../api';
import { useErrorStore } from './useErrorStore';

export interface Donation {
  id: number;
  donorID: number;
  date: string;
  amount: number;
  paymentMethod: string;
  name: string;
  phone: string;
  address: string;
  city: string;
  state: string;
  pincode: string;
  pan: string;
  gift: string;
  purpose: string;
  head: string;
  event: string;
  taxReceiptNo: string;
  email: string;
  txnRefId: string;
  campaignId: string | null;
  subPurpose: string;
}

interface DonationsState {
  donations: Donation[];
  loading: boolean;
  refresh: () => Promise<void>;
}

export const useDonationsStore = create<DonationsState>((set) => ({
  donations: [],
  loading: false,
  refresh: async () => {
    set({ loading: true });
    try {
      const data = await fetchDonations();
      set({ donations: Array.isArray(data) ? data : [], loading: false });
    } catch (error) {
      useErrorStore.getState().setError('Failed to fetch donations.');
      set({ loading: false });
    }
  },
}));
